import { useEffect } from 'react'
import type { EligibilityFormData } from '../types'
import { shouldResetUnavailableInPersonTraining } from './state'

type UseAdditionalInfoTrainingModeSyncArgs = {
  isInPersonAvailable: boolean
  setSelectionError: (value: string | null) => void
  shouldShowLaptopQuestion: boolean
  trainingMode: EligibilityFormData['trainingMode']
  updateFormData: (data: Partial<EligibilityFormData>) => void
}

export function useAdditionalInfoTrainingModeSync({
  isInPersonAvailable,
  setSelectionError,
  shouldShowLaptopQuestion,
  trainingMode,
  updateFormData
}: UseAdditionalInfoTrainingModeSyncArgs) {
  useEffect(() => {
    if (
      !shouldResetUnavailableInPersonTraining({
        isInPersonAvailable,
        shouldShowLaptopQuestion,
        trainingMode
      })
    ) {
      return
    }

    updateFormData({ trainingMode: undefined, hasLaptop: undefined })
    setSelectionError(null)
  }, [isInPersonAvailable, setSelectionError, shouldShowLaptopQuestion, trainingMode, updateFormData])
}
